// extracted by mini-css-extract-plugin
export default {"app":"app_app__OsQoD","scanner":"app_scanner__5OAvz","scannerCloseIcon":"app_scannerCloseIcon__nfLuI"};